import styles from "./PricingSection.module.css";

export default function PricingSection() {
    return (
        <section className={styles.section}>
            <div className={styles.container}>
                <h2 className={styles.title}>Natural Voices, Simple Pricing</h2>
                <p className={styles.subtitle}>
                    From startups to enterprises—pick a plan that fits your needs.
                    Upgrade, downgrade, or cancel anytime.
                </p>

                <div className={styles.offer}>
                    🎉 Limited Time Offer! Save flat 20% on all plans
                </div>

                <div className={styles.cards}>
                    {/* Starter */}
                    <div className={styles.card}>
                        <h3 className={styles.plan}>Starter</h3>
                        <p className={styles.desc}>
                            Perfect for individuals and small projects
                        </p>

                        <div className={styles.price}>
                            $29 <span>per month</span>
                        </div>

                        <button className={styles.primaryBtn}>Get Started</button>

                        <ul className={styles.list}>
                            <li>100,000 characters/month</li>
                            <li>All voice models</li>
                            <li>15+ emotional tones</li>
                            <li>12+ languages</li>
                            <li>WebSocket streaming</li>
                            <li>Email support</li>
                            <li>Commercial usage rights</li>
                        </ul>
                    </div>

                    {/* Professional */}
                    <div className={`${styles.card} ${styles.popular}`}>
                        <span className={styles.badge}>Most Popular</span>

                        <h3 className={styles.plan}>Professional</h3>
                        <p className={styles.desc}>
                            For growing businesses and applications
                        </p>

                        <div className={styles.price}>
                            $99 <span>per month</span>
                        </div>

                        <button className={styles.whiteBtn}>Get Started</button>

                        <ul className={styles.list}>
                            <li>500,000 characters/month</li>
                            <li>All voice models</li>
                            <li>15+ emotional tones</li>
                            <li>12+ languages</li>
                            <li>WebSocket streaming</li>
                            <li>Priority support</li>
                            <li>Commercial usage rights</li>
                            <li>Custom pronunciation</li>
                            <li>SSML support</li>
                        </ul>
                    </div>

                    {/* Enterprise */}
                    <div className={styles.card}>
                        <h3 className={styles.plan}>Enterprise</h3>
                        <p className={styles.desc}>For large-scale deployments</p>

                        <div className={styles.price}>
                            Custom <span>contact us</span>
                        </div>

                        <button className={styles.primaryBtn}>Contact Sales</button>

                        <ul className={styles.list}>
                            <li>Unlimited characters</li>
                            <li>All voice models</li>
                            <li>15+ emotional tones</li>
                            <li>12+ languages</li>
                            <li>WebSocket streaming</li>
                            <li>Dedicated support</li>
                            <li>Commercial usage rights</li>
                            <li>Custom pronunciation</li>
                            <li>SSML support</li>
                            <li>On-premise deployment</li>
                            <li>Custom voice cloning</li>
                            <li>SLA guarantee</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
